const config = {
  barChart: {
    Frånsorterat: {
      title: 'Frånsorterat',
      key: 'totalDiscardedPct',
    },
    Knäck: {
      title: 'Knäck',
      key: 'brokenPct',
    },
    Smuts: {
      title: 'Smuts',
      key: 'dirtyPct',
    },
  },
  detailsConfig: {
    freeRangeEgg_XL: {
      text: 'XL',
      bgColor: '#E7EDFF',
      name: 'Extra stora',
    },
    freeRangeEgg_L: {
      text: 'L',
      bgColor: '#FFF5D9',
      name: 'Stora',
    },
    freeRangeEgg_M: {
      text: 'M',
      bgColor: '#E7EDFF',
      name: 'Mellan',
    },
    freeRangeEgg_S: {
      text: 'S',
      bgColor: '#FFE0EB',
      name: 'Små',
    },
    secondClass: {
      text: '',
      bgColor: '#FFF5D9',
      name: 'Blodiga',
    },
    dirty: {
      text: '',
      bgColor: '#FFF5D9',
      name: 'Smutsiga',
    },
    broken: {
      text: '',
      bgColor: '#FFF5D9',
      name: 'Knäckta',
    },
    unacceptable: {
      text: '',
      bgColor: '#FFF5D9',
      name: 'Odugliga',
    },
    classASummary: {
      text: 'A',
      bgColor: '#FFF5D9',
      name: 'Kvalitetsklass A',
    },
    totalDiscarded: {
      text: '',
      bgColor: '#FFF5D9',
      name: 'Frånsorterade',
    },
    separatelyPacked: {
      text: '',
      bgColor: '#FFF5D9',
      name: 'Frånsorterade',
    },
    kgs_separately_packed: {
      text: '',
      bgColor: '#FFF5D9',
      name: 'Frånsorterade',
    },
  },
  lineChart: {
    settlementPrice: {
      title: 'Avräkningspris/kg',
      lastUpdated: '',
      // govKey: 'avgPriceKg',
      govKey: 'indoorPriceKg',
      userKey: 'settlementPriceKg',
      //userKey: 'netPriceKg',
    },
    deduction: {
      title: 'Prisavdrag/kg',

      govKey: 'avgPriceEgg',
      userKey: 'deduction',
    },
    netPrice: {
      title: 'Nettopris/kg',

      govKey: 'indoorPriceKg',
      userKey: 'netPriceKg',
    },
    foderNet: {
      title: 'Avräkningspris minus foderkostnad /kg ',

      govKey: 'indoorPriceKg',
      userKey: 'netPriceKg',
    },
  },
}

export default config
